import { mapConditions } from '@Sage/ssm-web5/dist/components/Conditions';
import { sortByProp } from 'utils/array';
import { t } from 'utils/getLiteral';

const FilterSchema = [
    {
        dataType: 'text',
        description: 'cfm_label_event_name',
        id: 'name',
    },
    {
        dataType: 'singleValueList',
        description: 'cfm_label_event_action',
        id: 'eventAction',
        options: 'eventActionOptions',
    },
    {
        dataType: 'singleValueList',
        description: 'cfm_label_event_related_entity',
        id: 'eventEntity',
        options: 'eventEntityOptions',
    },
    {
        dataType: 'boolselect',
        description: 'cfm_label_event_status',
        id: 'enabled',
        inputAttrs: {
            optionLabels: {
                yes: 'cfm_label_enabled',
                no: 'cfm_label_disabled',
            },
        },
    },
];

const CrudFields = ['conditions', 'description', 'enabled', 'function', 'name', 'type'];

export default class CustomEventsManager {
    constructor(api) {
        this.api = api;
    }

    getFilterSchema = () => sortByProp(FilterSchema, 'description', t);

    getCrudFields = () => CrudFields;

    getEvents = () =>
        this.api.getEvents().then((res) => {
            const result = this.mapperEventList(res);
            return result;
        });

    getEventTypeParams = () => this.api.getEventTypeParams();

    getCrudEvent = (name) => this.api.getCrudEvent(name);

    createEvent = ({ values }) => {
        const { name } = values;
        return this.api.createEvent(values).then(() => this.publishEvent(name));
    };

    updateEvent = (data) => {
        const { name, values } = data;
        return this.api.updateEvent(name, values).then(() => this.publishEvent(name));
    };

    deleteEvent = (name) => this.api.deleteEvent(name);

    publishEvent = (name) => this.api.publishEvent(name);

    getEntityParamsMapper = (entity) => this.api.getEntityParamsMapper(entity);

    getEventConditions = (data) => this.api.getEventConditions(data);

    getInitialCrudValues = (event) => {
        const obj = event || {};
        return {
            conditions: obj.conditions !== null ? mapConditions(obj.conditions) : null,
            description: obj.description || '',
            enabled: obj.enabled !== undefined ? obj.enabled : false,
            function: obj.functions && obj.functions.length > 0 ? obj.functions[0] : null,
            name: obj.name || '',
            type: obj.type || { name: 'database' },
        };
    };

    mapperEventList = (events) =>
        events.map(({ type, ...event }) => ({
            ...event,
            eventAction: type && type.params && type.params.action ? type.params.action : '',
            eventEntity: type && type.params && type.params.entity ? type.params.entity : '',
        }));
}
